import React from 'react';
import { Link } from 'react-router-dom';

import arrows_lips_sync from '../../assets/imgs/arrows/arrows-lips-heads.png'; 
import arrows01 from '../../assets/imgs/arrows/arrows-animator-unity.png'; 

import navina from '../../assets/imgs/navina/next_risk.png'; 


const ArrowsPage = () => {



  return (
    <div className='bg-light'>
      <div className='header-height'></div>
      <div className='row'>
        <div className='col-sm-2 col-xs-12'></div>
        <div className='col-sm col-xs-12'>
          <div className='row px-2 py-5 px-sm-5'>
            <div className='col-md col-xs-12 text-start mb-5'>
              <p className='fs-2 fw-normal lh-sm capitalize mb-2'>Arrows Social Skill Coach</p>
              <p className='fs-1rem fw-light capitalize'>
                    AI-Unity-React integration
                    </p>
              <p className='mt-3 fw-200'>2023</p>
            </div>
            <div className='col-md col-xs-12 mb-5'>
              <p className='fw-300 fs-5'>
              This project integrates AI, Unity, and React.js to create an interactive social skills coach designed for individuals with autism. The application features a real-time, AI-driven 3D human avatar that helps users practice social interactions in a controlled and supportive environment. 

              </p>
            </div>
            
            <div className='col-xs-12'>
              <div className='ratio ratio-16x9 mb-5'>
                <iframe
                  src="https://www.youtube.com/embed/wohVFqqRXzI"
                  title="Arrows demo video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className='row my-5'>
        <div className='col-sm-6 col-xs-12'></div>
        <div className='col-sm-6 col-xs-12 px-5 py-sm-5 py-2'>
          <p className='fs-5'>
          The 3D avatar model was meticulously designed to deliver realistic and context-aware interactions. Every aspect, from lip sync and facial expressions to body movements, was carefully crafted to enhance the natural flow of conversation. The lip sync system ensures that speech is accurately synchronized with mouth movements, while the facial expressions and gestures dynamically adapt to reflect emotions, reinforcing the authenticity of social interactions.
                    </p>
        </div>
      </div>

      <div className='row p-0'>
        <img className='py-2' src={arrows_lips_sync} width='100%'/>
      </div>

      <div className='row my-5'>
      <div className='col-sm-6 col-xs-12 px-5 py-sm-5 py-2'>
      <p className='fs-5'>
          At the core of the avatar’s responsiveness is a custom-built state machine, which processes real-time inputs to generate lifelike reactions. This system continuously evaluates speech patterns, user engagement, and contextual cues, determining the appropriate expression, gaze direction, and response timing. By integrating AI-driven decision-making, the avatar can adapt fluidly to different conversational scenarios, making the interaction feel intuitive and immersive.
          This combination of advanced animation design and real-time AI processing results in a highly interactive and intelligent social skills coach, helping users develop essential communication abilities through realistic, guided practice.
          </p>

        </div>
        <div className='col-sm-6 col-xs-12'></div>
      </div>



      <div className='row g-4 p-2 p-sm-5 m-0'>
      <div className='col-md'></div>
        <div className='col-md-6'>
        <video width="100%" height="auto"autoPlay loop muted>
            <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/arrows-controls-video_900x900.mp4" type="video/mp4" />
          </video>

          <div className='mb-4'></div>
          <img className='img-fluid' src={arrows01} alt="Navina Risk 2" />
          <div className='mb-4'></div>
          <video width="100%" height="auto"autoPlay loop muted>
            <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/arrows-interface.mp4" type="video/mp4" />
          </video>
          <div className='mb-4'></div>
          <video width="100%" height="auto"autoPlay loop muted>
            <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/arrows-avatar.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <div className='row py-5 px-3 px-sm-5'>
  <div className='col-sm-2 col-xs-12'></div>
    <div className='col-sm col-xs-12'>
          <div className='py-2'>
            <Link to={"https://ar-rows.com"}>
              <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
                <h5 className='fs-18 fw-600'>Client: Ar-rows.com</h5>
                <div className='arrow-out'></div>
              </a>
            </Link>
          </div>

          <div className='py-2'></div>
          <div className='d-block'>
            <h5 className=''>Credits:</h5>
            <ul className='p-0'>
              <li>Modeling and Animation: Paz Roth</li>
              <li>Game Development [Unity] and integration: Paz Roth</li>
              <li>Product Design: Eran Dvir</li>
              <li>Frontend Development: Paz Roth, Talya Eitan</li>
              <li>Backend Development: Lev Ferdinskoif</li>

            </ul>
          </div>

          <div className='py-2'></div>

          <div className='row'>
          <div className='col-sm col-xs-12'>
              <h5 className='fs-18 fw-600'>Capabilities</h5>
              <ul className='p-0'>
                <li className='py-1'>3D medling & rigging</li>
                <li className='py-1'>Explainer video</li>
                <li className='py-1'>3D animation</li>
                <li className='py-1'>Game Development</li>
                <li className='py-1'>Full Stack Development</li>
              </ul>
            </div>
            <div className='col-sm col-xs-12'>
            <h5 className='fs-18 fw-600'>Softwares</h5>
              <ul className='p-0'>
                <li className='py-1'>React.js</li>
                <li className='py-1'>Unity</li>
                <li className='py-1'>Maya</li>
                <li className='py-1'>AWS Services</li>
                <li className='py-1'>After Effects</li>
                <li className='py-1'>Photosop</li>

              </ul>
            </div>
            <div className='col-sm col-xs-12'>
            <h5 className='fs-18 fw-600'>Cooperation</h5>
              <ul className='p-0'>
                <li className='py-1'>Long-Term Project</li>
              </ul>
            </div>
            <div className='col-sm col-xs-12'>
            <h5 className='fw-600'>Industry</h5>
              <li className='py-1'>Technology, Education, SaaS</li>
              <h5 className='fw-600 pt-2'>Duration</h5>
              <li className='py-1'>4 Months</li>
            </div>
          </div>
        </div>
      </div>

      <div className='row mx-0 mt-3 mt-sm-5'>
      <div className='col-sm-12 col-xs-12 text-end p-5'>
          <Link to={"/navina-risk"}>
            <a className='fs-5 fw-bold text-dark'>
              Next work 
              <div className='arrow-right'></div>
            </a>
          </Link>
        </div>
          <div className='col-sm-2 col-xs-12 p-3 p-sm-5'></div>
            <div className='col-sm col-xs-12 p-0'>
          <Link to={"/navina-risk"}>
            <div className='image-box-300'>
              <img src={navina} alt="navina next" />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ArrowsPage;
